import { css, keyframes, styled } from 'styled-components';
import { Box } from '@design-system/box';
const placeHolderShimmer = (isLarge) => keyframes `
  0% {
    background-position: ${isLarge ? '50%' : '-350px'} 0;
  }
  100% {
    background-position: 0 0;
  }
`;
const getCSSAnimation = (isStatic, isLarge, theme) => !isStatic &&
    css `
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    background: #f6f7f8;
    background: ${`linear-gradient(to right, ${theme === null || theme === void 0 ? void 0 : theme.colors.cloud} 8%, ${theme === null || theme === void 0 ? void 0 : theme.colors.horizon} 18%, ${theme === null || theme === void 0 ? void 0 : theme.colors.cloud} 33%)`};
    background-repeat: no-repeat;
    background-size: ${isLarge ? '300%' : '1200px'} 800px;
    position: relative;
  `;
const getCSSAnimationName = (isStatic, isLarge) => !isStatic &&
    css `
    animation-name: ${placeHolderShimmer(isLarge)};
  `;
const Skeleton = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => !['isStatic', 'isLarge'].includes(prop),
})
    .attrs(({ height }) => ({
    bg: 'cloud',
    height: height !== null && height !== void 0 ? height : 12,
})) `
  ${({ isLarge, isStatic, theme }) => getCSSAnimation(isStatic, isLarge, theme)};
  ${({ isLarge, isStatic }) => getCSSAnimationName(isStatic, isLarge)};
  opacity: 0.4;
`;
export { Skeleton };
//# sourceMappingURL=Skeleton.js.map